
import signalRService from "../services/SignalRService";
import NonAvailabilityGroupEditModal from "./NonAvailabilityGroupEditModal.vue";

export default {
  name: "HolidayRequestsView",
  components: { NonAvailabilityGroupEditModal },
  props: {
    baseUrl: { type: String, required: true }
  },
  data() {
    return {
      requests: [] as any[],
      selectedStatus: "Pending",
      comments: {} as Record<string, string>,
      loading: false,
      actioningGroupId: "" as string,
      message: "",
      messageType: "",
      unsubscribePendingApprovals: null as (() => void) | null,
      nonAvailabilityTypes: [] as any[],
      editingGroupId: null as string | null,
      editingRecords: [] as any[]
    };
  },
  mounted() {
    this.fetchRequests();
    this.fetchNonAvailabilityTypes();
    this.unsubscribePendingApprovals = signalRService.onPendingApprovalsChanged(() => this.fetchRequests());
  },
  beforeUnmount() {
    if (this.unsubscribePendingApprovals) {
      this.unsubscribePendingApprovals();
    }
  },
  methods: {
    authHeaders() {
      const token = localStorage.getItem("token");
      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    },
    formatDate(dateValue: string): string {
      return new Date(dateValue).toLocaleDateString();
    },
    formatDateRange(request: any): string {
      return `${this.formatDate(request.startDate)} - ${this.formatDate(request.endDate)}`;
    },
    async fetchRequests() {
      this.loading = true;
      try {
        const response = await fetch(
          `${this.baseUrl}SecurityOfficers/NonAvailability/HolidayRequests?status=${this.selectedStatus}`,
          {
            method: "GET",
            headers: this.authHeaders()
          }
        );
        if (response.ok) {
          this.requests = await response.json();
        } else {
          this.message = "Failed to load holiday requests.";
          this.messageType = "alert-danger";
        }
      } catch (error) {
        console.error("Error loading holiday requests:", error);
        this.message = "Network error while loading holiday requests.";
        this.messageType = "alert-danger";
      } finally {
        this.loading = false;
      }
    },
    async decide(request: any, decision: "Approve" | "Reject") {
      this.actioningGroupId = request.recurrenceGroupId;
      this.message = "";
      try {
        const response = await fetch(
          `${this.baseUrl}SecurityOfficers/NonAvailability/Group/${request.recurrenceGroupId}/${decision}`,
          {
            method: "POST",
            headers: this.authHeaders(),
            body: JSON.stringify({ Comment: this.comments[request.recurrenceGroupId] || "" })
          }
        );
        if (response.ok) {
          await this.fetchRequests();
        } else if (response.status === 403) {
          this.message = "You are not authorized to approve or reject holiday requests.";
          this.messageType = "alert-danger";
        } else {
          this.message = `Failed to ${decision.toLowerCase()} request.`;
          this.messageType = "alert-danger";
        }
      } catch (error) {
        console.error(`Error ${decision.toLowerCase()}ing holiday request:`, error);
        this.message = `Network error while ${decision === "Approve" ? "approving" : "rejecting"} request.`;
        this.messageType = "alert-danger";
      } finally {
        this.actioningGroupId = "";
      }
    },
    async fetchNonAvailabilityTypes() {
      try {
        const response = await fetch(`${this.baseUrl}SecurityOfficers/NonAvailability/Types`, {
          method: "GET",
          headers: this.authHeaders()
        });
        if (response.ok) {
          this.nonAvailabilityTypes = await response.json();
        }
      } catch (error) {
        console.error("Error loading non-availability types:", error);
      }
    },
    async openGroupEditor(request: any) {
      try {
        const response = await fetch(`${this.baseUrl}SecurityOfficers/NonAvailability/${request.securityOfficerId}`, {
          method: "GET",
          headers: this.authHeaders()
        });
        if (response.ok) {
          this.editingRecords = await response.json();
          this.editingGroupId = request.recurrenceGroupId;
        } else {
          this.message = "Failed to load officer's non-availability records.";
          this.messageType = "alert-danger";
        }
      } catch (error) {
        console.error("Error loading officer's non-availability records:", error);
        this.message = "Network error while loading officer's non-availability records.";
        this.messageType = "alert-danger";
      }
    },
    async onGroupSaved() {
      this.editingGroupId = null;
      await this.fetchRequests();
    }
  }
};
